<div class="uni-widget-content-container">
    <ng-content></ng-content>
</div>
